import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";
import { useSettings } from "@/context/AppSettings";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const settings = useSettings();
  const [lang, setLang] = useState(() => localStorage.getItem("ap_lang") || "en");

  useEffect(() => {
    if (!localStorage.getItem("ap_lang") && settings.default_lang) {
      setLang(settings.default_lang);
    }
  }, [settings.default_lang]);

  useEffect(() => {
    localStorage.setItem("ap_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => path.split(".").reduce((o, k) => o?.[k], translations[lang]) ?? path;

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
